import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
};

const violationsRoleSlice = createSlice({
  name: 'aag/violationsRole',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

const { reducer: violationsRoleReducer, actions } = violationsRoleSlice;

export const violationsRoleActions = actions;
export default violationsRoleReducer;
